import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

// Connects to data-controller="admin-dashboard"
export default class extends Controller {
  static values = { 
    channel: String 
  }
  
  static targets = [ 
    "currentTime" 
  ]

  connect() {
    console.log("Admin Dashboard controller connected")
    
    // Démarrer l'horloge en temps réel
    this.startClock()
    
    // Se connecter au canal Action Cable pour les mises à jour
    this.subscribeToChannel()
  }

  disconnect() {
    // Nettoyer l'intervalle de l'horloge
    if (this.clockInterval) {
      clearInterval(this.clockInterval)
    }
    
    // Se déconnecter du canal
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
  }

  startClock() {
    // Mettre à jour l'heure chaque seconde
    this.clockInterval = setInterval(() => {
      if (this.hasCurrentTimeTarget) {
        const now = new Date()
        const timeString = now.toLocaleTimeString('fr-FR', {
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        })
        this.currentTimeTarget.textContent = timeString
      }
    }, 1000)
  }

  subscribeToChannel() {
    if (!this.channelValue) {
      console.log("No channel specified for admin dashboard")
      return
    }

    // Créer un consumer Action Cable
    this.consumer = createConsumer()
    
    // S'abonner au canal admin_dashboard
    this.subscription = this.consumer.subscriptions.create(
      { channel: "AdminDashboardChannel" },
      {
        connected: () => {
          console.log("Connected to AdminDashboardChannel")
        },

        disconnected: () => {
          console.log("Disconnected from AdminDashboardChannel")
        },

        received: (data) => {
          console.log("Received data from AdminDashboardChannel:", data)
          this.updateWidget(data)
        }
      }
    )
  }

  updateWidget(data) {
    const { widget, html } = data
    
    if (!widget || !html) {
      console.warn("Invalid widget update data:", data)
      return
    }

    // Trouver l'élément du widget à mettre à jour
    const widgetElement = document.getElementById(`${widget}_widget`)
    
    if (widgetElement) {
      // Mettre à jour le contenu du widget avec les nouvelles données
      widgetElement.innerHTML = html
      
      // Ajouter un effet visuel pour indiquer la mise à jour
      this.flashWidget(widgetElement)
    } else {
      console.warn(`Widget element not found: ${widget}_widget`)
    }
  }

  flashWidget(element) {
    // Ajouter une classe pour l'effet de flash
    element.classList.add('bg-blue-50', 'border-blue-200')
    
    // Retirer l'effet après un court délai
    setTimeout(() => {
      element.classList.remove('bg-blue-50', 'border-blue-200')
    }, 1000)
  }

  // Action pour rafraîchir manuellement un widget
  refreshWidget(event) {
    const widgetType = event.params.widget
    
    if (!widgetType) {
      console.warn("No widget type specified for refresh")
      return
    }

    // Faire une requête pour rafraîchir le widget
    fetch(`/admin/dashboard/refresh_widget?widget_type=${widgetType}`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Content-Type': 'application/json'
      }
    }).then(response => {
      if (!response.ok) {
        console.error("Failed to refresh widget:", widgetType)
      }
    }).catch(error => {
      console.error("Error refreshing widget:", error)
    })
  }
}
